/**
 * Users module constants
 */

export const ADD_USER = 'ADD_USER';
export const GET_USERS = 'GET_USERS';
export const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const MODIFY_USER = 'MODIFY_USER';
export const SET_EDITING_USER = 'SET_EDITING_USER';
export const SET_USERS_FILTERS = 'SET_USERS_FILTERS';
export const SET_USERS_PAGINATION = 'SET_USERS_PAGINATION';
export const TOGGLE_USER = 'TOGGLE_USER';
export const UPDATE_USER = 'UPDATE_USER';



// WEBPACK FOOTER //
// src/modules/secured/modules/users/constants/users_constants.js